module.exports = __webpack_public_path__ + "static/media/C6.81d00a27.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/C6.png
// module id = 898
// module chunks = 0